export default __webpack_public_path__ + "static/media/sessions_tg_terminate_ru.13b017cb.jpg";